import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Descriptions, Divider, Button, Row, Col, Space } from 'antd'
import { EditOutlined, DownloadOutlined, FileMarkdownOutlined } from '@ant-design/icons';
import { checkPermission } from '@/utils/permission';
import ReactHtmlParser from 'react-html-parser';
import { isMobile } from 'react-device-detect';
import { downloadFromLink, isValidDate, renderBooleanIcon } from '@/utils/helpers';
import ProcedureForm from './ProcedureForm';

class ProcedureDetail extends Component {

    constructor() {
        super();
        this.state = {
            isOpenEditForm: false,
            currentItem: null
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

    }

    handleCancel() {
        this.props.onCancel();
    }

    toggleOpenEditForm(isOpenEditForm) {
        this.setState({ isOpenEditForm: isOpenEditForm });
    }

    onDownload(url) {
        setTimeout(() => {
            const response = {
                file: url,
            };
            downloadFromLink(response.file);
        }, 100);
    }

    render() {
        var { isOpenEditForm } = this.state;
        var { visible, currentItem } = this.props;

        return (
            <>
                <Drawer
                    visible={visible}
                    title={currentItem && currentItem.name ? currentItem.name : "Chi tiết thủ thuật"}
                    onClose={() => this.handleCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '70%'}
                    extra={
                        checkPermission('procedures', 'update') ? (
                            <Button type="primary" onClick={() => this.toggleOpenEditForm(true)} icon={<EditOutlined />}>Sửa</Button>
                        ) : null
                    }
                >
                    {visible ? (
                        <div>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Tên thủ thuật">
                                            {currentItem ? currentItem.name : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Mã thủ thuật">
                                            {currentItem ? currentItem.code : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Mô tả chi tiết">
                                            {currentItem ? currentItem.description : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Điểm đánh giá">
                                            {currentItem ? currentItem.pain_score : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Tài liệu">
                                            {
                                                currentItem?.documents && currentItem?.documents.length ? (
                                                    <Space wrap>
                                                        <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }} >
                                                            {
                                                                currentItem?.documents.map(item => {
                                                                    return (
                                                                        <li><FileMarkdownOutlined /> {item.name} &nbsp; <DownloadOutlined style={{ color: 'blue' }} onClick={() => this.onDownload(item.data)} /></li>
                                                                    )
                                                                })
                                                            }
                                                        </ul>
                                                    </Space>
                                                ) : null
                                            }
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Ghi chú">
                                            {currentItem ? ReactHtmlParser(currentItem.note) : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Trạng thái">
                                            {renderBooleanIcon(currentItem.status)}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Ngày tạo">
                                            {currentItem ? isValidDate(currentItem.created_at) : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Người tạo">
                                            {currentItem ? currentItem.created_user.full_name : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                            </Row>
                        </div>
                    ) : null}

                </Drawer>
                <ProcedureForm
                    visible={isOpenEditForm}
                    currentItem={currentItem}
                    reloadData={() => this.props.reloadData()}
                    onCancel={() => this.toggleOpenEditForm(false)}
                />
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'ProcedureDetail' })(ProcedureDetail));
